export const tableOption = {
  border: false,
  index: true,
  indexLabel: '序号',
  indexFixed: true,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  menuWidth: '200px',
  addBtn: false,
  // "menuFixed": false,
  menu: true,
  delBtn: false,
  editBtn: false,
  searchBtn: true,
  searchShow: false,
  selectClearBtn: false,
  refreshBtn: false,
  columnBtn: false,
  column: []
}
export const column1 = [
  {
    label: '项目标题',
    type: 'input',
    prop: 'title',
    minWidth: '220px',
    // overHidden: true,
    slot: true,
    fixed: 'left'
  },
  {
    label: '项目类型',
    type: 'input',
    prop: 'sceneTypeDesc',
    minWidth: '120px',
    // overHidden: true,
    slot: true,
    fixed: 'left'
  },
  {
    label: '收藏',
    prop: 'isStar',
    width: '60px',
    slot: true,
    name: 'star',
    fixed: 'left'
  }
]
// 换壳/定制企业 不显示 问卷id
export const surveyIdOption = [
  {
    label: '项目ID',
    type: 'input',
    prop: 'id',
    width: '120px',
    fixed: 'left',
    slot: true,
    hide: false
  }
]
export const column2 = [
  {
    label: '项目状态',
    prop: 'publishStatus',
    width: '150px',
    slot: true,
    name: 'status',
    fixed: 'left'
  },
  {
    label: '回收数据',
    prop: 'answerRecoveryAmount',
    width: '120px',
    sortable: true
  },
  /*     {
        "label": "发布渠道",
        "prop": "channels",
        "width": "200px",
        "sortable": true
      }, */
  {
    label: '创建时间',
    prop: 'createTime',
    width: '110px',
    sortable: true
  },
  {
    label: '更新时间',
    prop: 'updateTime',
    width: '110px',
    sortable: true
  }
]

export const mcafColumn = [
  {
    label: '项目标题',
    type: 'input',
    prop: 'title',
    minWidth: '220px',
    // overHidden: true,
    slot: true,
    fixed: 'left'
  },
  {
    label: '项目类型',
    type: 'input',
    prop: 'sceneTypeDesc',
    minWidth: '120px',
    // overHidden: true,
    slot: true,
    fixed: 'left'
  },
  {
    label: '项目ID',
    type: 'input',
    prop: 'id',
    width: '120px',
    fixed: 'left',
    slot: true,
    hide: false
  },
  {
    label: '项目状态',
    prop: 'status',
    width: '150px',
    slot: true,
    name: 'status',
    fixed: 'left'
  },
  // {
  //   label: '回收数据',
  //   prop: 'answerRecoveryAmount',
  //   width: '120px',
  //   sortable: true
  // },
  {
    label: '创建时间',
    prop: 'createdAt',
    width: '110px',
    sortable: true
  },
  {
    label: '更新时间',
    prop: 'updatedAt',
    width: '110px',
    sortable: true
  }
]

export const recycleOption = {
  border: false,
  index: true,
  indexLabel: '序号',
  indexFixed: true,
  stripe: true,
  menuAlign: 'center',
  menu: false,
  align: 'center',
  menuWidth: '79px',
  addBtn: false,
  delBtn: false,
  editBtn: false,
  searchBtn: false,
  searchShow: false,
  refreshBtn: false,
  columnBtn: false,
  selection: true, // 多选
  reserveSelection: true, // 保留之前的勾选
  column: [
    {
      label: '问卷标题',
      type: 'input',
      prop: 'title',
      minWidth: '220px',
      // overHidden: true,
      slot: true,
      fixed: 'left'
    },
    {
      label: '星标',
      prop: 'isStar',
      width: '60px',
      slot: true,
      name: 'star',
      fixed: 'left'
    },
    {
      label: '问卷ID',
      type: 'input',
      prop: 'id',
      width: '120px',
      fixed: 'left'
    },
    {
      label: '问卷状态',
      prop: 'publishStatus',
      width: '150px',
      slot: true,
      name: 'status',
      fixed: 'left'
    },
    {
      label: '回收数据',
      prop: 'answerRecoveryAmount',
      width: '120px',
      sortable: true
    },
    {
      label: '创建时间',
      prop: 'createTime',
      width: '170px',
      sortable: true
    },
    /*   {
      "label": "发布渠道",
      "prop": "channels",
      "width": "300px",
      "sortable": true
    }, */
    {
      label: '移入时间',
      prop: 'delTime',
      width: '170px',
      sortable: true
    } /* , {
      "label": '有无未结算督导任务',
      "prop": 'settle',
      "name": 'settle',
      slot: true
      // "width": ''
    } */
  ]
}
export const offlineOption = {
  indexLabel: '序号',
  selection: true,
  border: true,
  index: true,
  addBtn: false,
  delBtn: false,
  editBtn: false,
  align: 'center',
  menuWidth: '280px',
  searchShow: false,
  searchBtn: false,
  column: [
    {
      label: '任务名称',
      prop: 'executionName',
      width: '210px',
      name: 'executionName',
      slot: true
    },
    {
      label: '任务状态',
      prop: 'status',
      width: '80px',
      slot: true,
      name: 'status'
    },
    {
      label: '任务ID',
      prop: 'id',
      width: '210px',
      name: 'id'
    },
    {
      label: '调查员手机号',
      prop: 'executorPhone',
      width: '120px',
      name: 'executorPhone'
    },
    {
      label: '截止时间',
      prop: 'executionValidateTo',
      width: '240px',
      name: 'executionValidateTo'
    },
    {
      label: '创建时间',
      prop: 'createTime',
      width: '240px',
      name: 'createTime'
    },
    {
      label: '答卷数量',
      prop: 'executionQuantity',
      width: '80px',
      name: 'executionQuantity'
    },
    {
      label: '答卷单价（元）',
      prop: 'executionSingleAmount',
      width: '120px',
      name: 'executionSingleAmount'
    },
    {
      label: '提交数量',
      prop: 'recycledQuantity',
      width: '80px',
      name: 'recycledQuantity'
    },
    {
      label: '有效数量',
      prop: 'effectiveQuantity',
      width: '80px',
      name: 'effectiveQuantity'
    },
    {
      label: '状态',
      prop: 'offlineStatus',
      width: '80px',
      slot: true,
      name: 'offlineStatus'
    }
  ]
}
export const sampleColumn = [
  {
    label: '序号',
    fixed: 'left',
    prop: 'index'
  },
  {
    label: '样本ID',
    type: 'input',
    prop: 'id',
    minWidth: '180px',
    fixed: 'left'
  },
  {
    label: '姓名',
    prop: 'sampleName',
    fixed: 'left'
  },
  {
    label: '手机号',
    prop: 'samplePhone',
    minWidth: '120px',
    fixed: 'left'
  },
  {
    label: '微信昵称',
    prop: 'accountUserWxNickname'
  },
  {
    label: '邮箱',
    prop: 'email',
    minWidth: '120px'
  },
  // {
  //   label: '所在地',
  //   prop: 'answerAddress',
  //   minWidth: '150px',
  // },
  // {
  //   label: '真实姓名',
  //   prop: 'realName'
  // },
  {
    label: '性别',
    prop: 'genders'
  },
  {
    label: '出生日期',
    prop: 'birthday',
    minWidth: '120px'
  },
  {
    label: '当前年龄',
    prop: 'currentAge',
    hasMaxMinValue: true
  },
  // {
  //   label: '证件类型',
  //   prop: 'certificateType'
  // },
  {
    label: '证件号',
    prop: 'idNumber',
    minWidth: '180px'
  },
  {
    label: '合格答卷数',
    prop: 'qualifiedAnswerCount',
    hasMaxMinValue: true,
    minWidth: '100px'
  },
  {
    label: '标签',
    prop: 'tags'
  },
  {
    label: '状态',
    prop: 'status',
    minWidth: '100px',
    slot: true
  },
  {
    label: '加入时间',
    prop: 'submitTime',
    minWidth: '220px',
    hasMaxMinValue: true
  },
  {
    label: '操作',
    prop: 'm_menu',
    fixed: 'right',
    width: '200px',
    slot: true
  }
]
export const sampleOption = {
  // 序号 列
  /*'index': true,
  'indexLabel': '序号',
  'indexFixed': true,*/

  border: true,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  menuWidth: '200px',
  addBtn: true,
  selection: true,
  tip: false,
  menu: false,
  delBtn: false,
  editBtn: false,
  searchBtn: true,
  searchShow: false,
  selectClearBtn: false,
  refreshBtn: false,
  columnBtn: false,
  column: sampleColumn
  /*  .map(item => {
  item.hide = true
  return item
})*/
}

function transformText2Item(item) {
  return {
    label: item,
    value: item
  }
}

const selects = [
  'names',
  'phones',
  'statuses',
  'genders',
  'certificateTypes',
  'channels',
  'accountUserIds',
  'maritalStatuses',
  'monthlyIncomeRanges'
]
const cascaders = ['currentLocations', 'domiciles', 'specialities', 'schools']
const inputs = ['realName', 'certificateNum', 'qualifiedAnswerCount', 'keyword', 'tags']
const datePickers = ['birthday', 'submitTime']
const hasMaxMinValues = ['birthday', 'submitTime', 'qualifiedAnswerCount']
const sampleFilters = [
  {
    label: '样本ID/姓名/手机号/微信昵称（完整值查询）',
    prop: 'keyword',
    hide: false
  },
  // {
  //   label: '姓名（下拉选择）',
  //   prop: 'names'
  // },
  // {
  //   label: '手机号（下拉选择）',
  //   prop: 'phones',
  // },
  /* {
     label: '当前所在地',
     prop: 'currentLocations',
     options: []
   },*/
  {
    label: '状态（下拉选择）',
    prop: 'statuses',
    // 答卷状态 0=待质控,1=质控通过,2=质控拒绝,3=正在答题,4=被甄别,5=超时,6=超额,7=测试,8=待审核,9=审核拒绝
    options: [
      {
        label: '待质控',
        value: '0'
      },
      {
        label: '质控通过',
        value: '1'
      },
      {
        label: '质控拒绝',
        value: '2'
      },
      {
        label: '正在答题',
        value: '3'
      },
      {
        label: '被甄别',
        value: '4'
      }
    ]
  },
  /*{
    label: '真实姓名（完整值查询）',
    prop: 'realName',
  },*/
  {
    label: '性别',
    prop: 'genders',
    options: [
      {
        label: '男',
        value: '男'
      },
      {
        label: '女',
        value: '女'
      }
    ]
  },
  /*{
    label: '证件类型',
    prop: 'certificateTypes',
    options: [
      {
        label: '身份证',
        value: '身份证'
      },
      {
        label: '军官证',
        value: '军官证'
      },
      {
        label: '港澳台胞证',
        value: '港澳台胞证'
      },
      {
        label: '护照',
        value: '护照'
      }
    ]
  },*/
  {
    label: '身份证号（完整值查询）',
    prop: 'certificateNum'
  },
  {
    label: '出生日期范围',
    prop: 'birthday',
    format: 'yyyy-MM-dd HH:mm:ss'
  },
  {
    label: '加入日期范围',
    prop: 'submitTime',
    format: 'yyyy-MM-dd HH:mm:ss'
  },
  {
    label: '合格答卷数范围',
    prop: 'qualifiedAnswerCount',
    min: '',
    max: ''
  },
  {
    label: '标签',
    prop: 'tags'
  },
  {
    label: '加入方式',
    prop: 'channels',
    value: '',
    multiple: true,
    options: [
      {
        label: '后台添加',
        value: 3
      },
      {
        label: '邀请添加',
        value: 4
      }
    ]
  },
  {
    label: '添加人',
    prop: 'accountUserIds'
  }
  /*{
    label: '婚姻状况',
    prop: 'maritalStatuses',
    options: ['已婚', '未婚', '离异', '丧偶'].map(transformText2Item)
  },
  {
    label: '个人月收入',
    prop: 'monthlyIncomeRanges',
    options: [
      '小于3001元', '3001~5000', '5001~10000元', '10001~15000元', '15001~20000元', '20001元以上'
    ].map(transformText2Item)
  },*/
]
sampleFilters.forEach(filterItem => {
  filterItem.lg = 6
  filterItem.sm = 24
  filterItem.md = 8
  if (!('hide' in filterItem)) {
    filterItem.hide = true
  }
  if (selects.includes(filterItem.prop)) {
    filterItem.type = 'select'
    if ('value' in filterItem) {
      filterItem.originvalue = filterItem.value
    } else {
      filterItem.value = []
      filterItem.originvalue = []
      filterItem.multiple = true
    }
    if (!filterItem.options) {
      filterItem.options = []
    }
  } else if (cascaders.includes(filterItem.prop)) {
    filterItem.type = 'cascader'
    filterItem.multiple = true
    filterItem.lastParams = true
    filterItem.value = []
    filterItem.originvalue = []
  } else if (inputs.includes(filterItem.prop)) {
    filterItem.type = 'input'
    filterItem.value = ''
    filterItem.originvalue = ''
  } else if (datePickers.includes(filterItem.prop)) {
    filterItem.type = 'date-picker'
    filterItem.value = []
    filterItem.originvalue = []
    filterItem.lg = 12
    filterItem.sm = 24
    filterItem.md = 16
  }
  if (hasMaxMinValues.includes(filterItem.prop)) {
    filterItem.hasMaxMinValue = true
  }
})
export { sampleFilters }
